import Vue from "vue";

async function logger(developerMessage, errorOrEvent) {
  console.error(developerMessage, errorOrEvent);

  // Run background API call to save error details so developers can inspect later on
  // fetch(
  //   process.env.NODE_ENV === "production"
  //     ? "https://tp-temperature-taking-api-yxnf3qma3a-as.a.run.app/error/new"
  //     : "http://localhost:3000/error/new",

  //   // Default options are marked with *
  //   {
  //     method: "POST",
  //     cache: "no-cache",
  //     credentials: "same-origin", // include, *same-origin, omit
  //     referrerPolicy: "no-referrer", // no-referrer, *client

  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       // Save the datetime of incident
  //       time: new Date().toString(),
  //       description: developerMessage,
  //       error: errorOrEvent.message || errorOrEvent,
  //     }),
  //   }
  // )
  //   .then((res) => res.json())
  //   .then((res) => console.assert(res.ok, "[Failed to save error]", res.error))
  //   .catch((err) => console.error("[Failed to save error]", err));

  // Log to user, easier to debug for now...
  alert(
    "Error! Contact developers for help\nOr relaunch app / Reinstall app" +
      "\n\n" +
      developerMessage +
      "\n" +
      errorOrEvent.message || errorOrEvent
  );
}

Vue.config.errorHandler = (err) => logger("Vue.config.errorHandler", err);

// event.reason contains the reason for the rejection
// event.promise contains the promise object
window.addEventListener("unhandledrejection", (event) =>
  logger("window.addEventListener.unhandledrejection", event)
);

window.onerror = (message, source, lineno, colno, error) =>
  logger("window.onerror", {
    error: error.message,
    message,
    source,
    lineno,
    colno,
  });
